module.exports = __webpack_public_path__ + "img/Liquid waste.9804beb9.svg";